<template>
  <div class="main">
    <HeaderTitle title="SGN Info">
      <IconTable color="#14444f" size="w-11 h-11" />
    </HeaderTitle>
    <MainContent>
      <div class="pt-5 pb-5">
        <div class="flex gap-8">
          <CardDetail
            menu="Total Feature"
            :detail="total_feature"
            :loading="sgnTotal.loading"
            background="bg-blue-300"
          />
          <CardDetail
            menu="Jumlah Dipesan"
            :detail="jumlah_dipesan"
            :loading="sgnTotal.loading"
            background="bg-green-300"
            text="text-green-900"
          />
          <CardDetail
            menu="Jumlah Belum Dipesan"
            :detail="jumlah_belum_dipesan"
            :loading="sgnTotal.loading"
            background="bg-purple-300"
            text="text-purple-900"
          />
        </div>

        <div
          class="pt-5"
          v-if="!sgnTotalStore.sgnTotalDetail.loading && !sgnTotal.loading"
        >
          <div
            class="overflow-x-auto relative shadow-md rounded-lg"
            v-if="sgnTotalStore.sgnTotalDetail.rows?.length != 0"
          >
            <table class="w-full text-sm text-left text-gray-500">
              <thead>
                <tr class="bg-white border-b">
                  <th scope="row" class="py-3 px-3 text-center">#</th>
                  <th scope="row" class="py-3 px-3 text-center">Feature ID</th>
                  <th scope="row" class="py-3 px-2 text-center">Kode Petak</th>
                </tr>
              </thead>

              <tbody>
                <tr
                  class="bg-white border-b text-center"
                  v-for="(item, index) in sgnTotalStore.sgnTotalDetail.rows"
                  :key="index"
                >
                  <td>{{ (page - 1) * limit + (index + 1) }}</td>
                  <td class="py-2 px-3">{{ item.feature_id }}</td>
                  <td class="py-2 px-2">{{ item.kode_petak }}</td>
                </tr>
              </tbody>
            </table>
            <PaginationComponent
              v-model:length="length"
              v-model:size="limit"
              v-model:page="page"
              @onSelectChange="changePage"
            />
          </div>
        </div>

        <LoadingLottie
          v-if="sgnTotalStore.sgnTotalDetail.loading || sgnTotal.loading"
        ></LoadingLottie>
        <div
          class="flex justify-center"
          v-if="sgnTotalStore.sgnTotalDetail.rows?.length == 0"
        >
          <NoData size="w-full md:w-5/12" />
        </div>
        <AlertErrorComponent
          v-if="sgnTotalStore.sgnTotalDetail.error"
          :message="sgnTotalStore.sgnTotalDetail.error.response.data.message"
        />
      </div>
    </MainContent>
  </div>
</template>
<script>
import HeaderTitle from "@/components/HeaderTitle.vue";
import MainContent from "@/components/MainContent.vue";
import CardDetail from "@/components/CardDetail.vue";
import PaginationComponent from "@/components/PaginationComponent.vue";
import LoadingLottie from "@/components/LoadingLottie.vue";
import NoData from "@/components/NoData.vue";
import AlertErrorComponent from "@/components/AlertErrorComponent.vue";
import IconTable from "@/components/icons/IconTable.vue";
import { useSgnTotalStore } from "@/store";
import { storeToRefs } from "pinia";
import { onMounted, ref } from "vue";

export default {
  components: {
    HeaderTitle,
    MainContent,
    CardDetail,
    PaginationComponent,
    LoadingLottie,
    NoData,
    AlertErrorComponent,
    IconTable,
  },
  setup() {
    const sgnTotalStore = useSgnTotalStore();
    const { sgnTotal } = storeToRefs(sgnTotalStore);

    const total_feature = ref(0);
    const jumlah_dipesan = ref(0);
    const jumlah_belum_dipesan = ref(0);

    const offset = ref(0);
    const limit = ref(50);
    const length = ref(0);
    const page = ref(1);

    const getTotal = async () => {
      await sgnTotalStore.getTotal();
      total_feature.value = sgnTotal.value.result[0].total_feature;
      jumlah_dipesan.value = sgnTotal.value.result[0].jumlah_dipesan;
      jumlah_belum_dipesan.value = sgnTotal.value.result[0].jumlah_belum_dipesan;
    };

    const getDetail = async () => {
      await sgnTotalStore.getDetail({});
      length.value = sgnTotalStore.sgnTotalDetail.count;
    };

    onMounted(async () => {
      await getTotal();
      await getDetail();
    });

    const changePage = async (value) => {
      page.value = value;
      offset.value = (page.value - 1) * limit.value;
      await sgnTotalStore.getDetail({ offset: offset.value });
      length.value = sgnTotalStore.sgnTotalDetail.count;
    };

    return {
      sgnTotal,
      total_feature,
      jumlah_dipesan,
      jumlah_belum_dipesan,
      changePage,
      sgnTotalStore,
      limit,
      length,
      page,
    };
  },
};
</script>
<style></style>
